import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/pro-solid-svg-icons/faCircle';

import React, { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import DataDrivenLogo from '../../../../../components/data-driven-logo';
import { useTrackWorkflow, WorkflowSteps } from '../../../../../tracking/use-workflow-tracking';
import { Workflows } from '../../../../../tracking/tracking-constants';
import { getButtonProperties } from './utils';

import messages from './messages';
import styles from './style.module.less';

const StoreRow = ({ store, disabled = false }) => {
  const history = useHistory();
  const location = useLocation();
  const { name, url } = store;
  const { theme: buttonTheme, text: buttonText, disabled: disabledButton, isLoading } = getButtonProperties(store);
  const buttonIsDisabled = disabledButton || disabled;
  const trackActivateEnhancedReturns = useTrackWorkflow(Workflows.ACTIVATE_ENHANCED_RETURNS_FLOW);

  const onClickStore = useCallback(() => {
    trackActivateEnhancedReturns(WorkflowSteps.SELECT_STORE, {
      storeGuid: store.storeGuid,
      storeName: name,
    });

    history.push(`${location.pathname}/activate/${store.storeGuid}`);
  }, [history, location.pathname, name, store.storeGuid, trackActivateEnhancedReturns]);

  return (
    <div className={styles['store-row']}>
      <div className={styles['store-row__info']}>
        <DataDrivenLogo className={styles['store-row__logo']} logoType='icon' marketplaceId={store.marketplaceId} />
        <div className={styles['store-row__label']}>
          <FormattedMessage {...messages.storeName} values={{ name }} />
          {url && <StoreRowDetails name={name} url={url} />}
        </div>
      </div>

      <Button
        className={styles['store-row__button']}
        disabled={buttonIsDisabled}
        isLoading={isLoading}
        onClick={onClickStore}
        theme={buttonTheme}
      >
        {buttonText}
      </Button>
    </div>
  );
};

const StoreRowDetails = ({ name, url }) => (
  <div className={styles['store-row__details']}>
    {name} <FontAwesomeIcon className={styles['store-row__circle']} icon={faCircle} /> {url}
  </div>
);

export default StoreRow;
